var constants = require('../constants');
var api = require('../../../utils/api');
var commonActions = require('../../common/actions/common');

var SpecialistActions = (function(){

    var _setMySpecialistRequest = function() {
        return {
            type: constants.SET_MY_SPECIALIST_REQUEST
        };
    }

    var _setMySpecialistSuccess = function(specialist) {
        return function (dispatch, getState) {
            dispatch({
                type: constants.SET_MY_SPECIALIST_SUCCESS,
                specialist: specialist || {}
            });

            if(specialist && specialist._id){
                api.get('/proxy/v1/practices?providerid=' + specialist._id, getState().auth.token)
                    .then(function(data){
                        dispatch({
                            type: constants.SET_MY_SPECIALIST_PRACTICE,
                            practice: (data && data.practices && data.practices[0]) || {}
                        });
                    });
            }
        };
    }

    var _setMySpecialistFailure = function(error) {
         return {
             type: constants.SET_MY_SPECIALIST_FAILURE
         };
     }

    var _setMySpecialist = function(specialist, token) {
        return function (dispatch) {
            dispatch(_setMySpecialistRequest());
            return api.patch('/proxy/v1/profiles', { // eslint-disable-next-line
                provider: specialist && specialist._id || null
            }, token).then(function () {
                return dispatch(_setMySpecialistSuccess(specialist));
            }).catch(function(error){
                dispatch(_setMySpecialistFailure());
                if(error.response){
                    dispatch(commonActions.setGenericResponseError('', error.response));
                }else{
                    dispatch(commonActions.setGenericError('', error.message));
                }
            });
        };
    }

    var _clearMySpecialist = function(token){
        return _setMySpecialist(null, token);
    }

    var _setSpecialistPendingAction = function(pendingAction){
        return {
            type: constants.SET_SPECIALIST_PENDING_ACTION,
            pendingAction: pendingAction
        };
    }

    var _removeSpecialistPendingAction = function(){
        return {
            type: constants.REMOVE_SPECIALIST_PENDING_ACTION
        };
    }

    return {
        setMySpecialist: _setMySpecialist,
        clearMySpecialist: _clearMySpecialist,
        setMySpecialistSuccess: _setMySpecialistSuccess,
        setSpecialistPendingAction: _setSpecialistPendingAction,
        removeSpecialistPendingAction: _removeSpecialistPendingAction
    }
})();

module.exports = SpecialistActions;



// WEBPACK FOOTER //
// ./src/common/modules/specialists/actions/specialist.js